export const ACTIVE_PATIENTS = [
  {
    id: "beatriz",
    name: "Beatriz Lima",
    age: 38,
    plan: "Particular",
    lastVisit: "15/03/2025",
    complaint:
      "Dores de cabeça recorrentes e fadiga leve nas últimas duas semanas.",
    alerts: ["Alergia a Dipirona"],
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=128&h=128&fit=crop",
    history: [
      {
        id: 1,
        date: "15/03/2025",
        title: "Consulta de Rotina",
        doctor: "Dr. Carlos Silva",
        summary:
          "Paciente compareceu para check-up anual. PA 120/80 mmHg. Exames laboratoriais dentro da normalidade. Orientada quanto à hidratação e sono regular.",
      },
      {
        id: 2,
        date: "02/11/2024",
        title: "Retorno — Cefaleia",
        doctor: "Dr. Carlos Silva",
        summary:
          "Melhora do quadro de cefaleia após ajuste de rotina. Mantida conduta anterior. Sem novas queixas.",
      },
      {
        id: 3,
        date: "18/06/2024",
        title: "Primeira Consulta",
        doctor: "Dra. Mariana Souza",
        summary:
          "Queixa inicial de fadiga. Solicitados hemograma completo e dosagem de vitamina D. Retorno agendado com resultados.",
      },
    ],
  },
  {
    id: "roberto",
    name: "Roberto Mendes",
    age: 52,
    plan: "Unimed",
    lastVisit: "28/01/2025",
    complaint: "Acompanhamento de pressão arterial e ajuste de medicação.",
    alerts: [],
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=128&h=128&fit=crop",
    history: [
      {
        id: 1,
        date: "28/01/2025",
        title: "Consulta Cardiológica",
        doctor: "Dr. Carlos Silva",
        summary:
          "Hipertensão controlada. Mantido Losartana 50mg 1x/dia. Reforçada dieta hipossódica.",
      },
    ],
  },
];

export const ANAMNESE_SNIPPETS = [
  "Paciente nega febre, comorbidades ou alergias conhecidas.",
  "Ausculta cardíaca e pulmonar sem alterações.",
  "Paciente refere melhora dos sintomas desde a última consulta.",
  "Exame físico geral sem alterações significativas.",
  "Orientado repouso, hidratação e retorno se piora do quadro.",
  "Sinais vitais estáveis. PA, FC e temperatura dentro da normalidade.",
];

export const MEDICATIONS = [
  "Paracetamol 750mg",
  "Ibuprofeno 600mg",
  "Dipirona 500mg",
  "Amoxicilina 500mg",
  "Losartana 50mg",
  "Omeprazol 20mg",
  "Dorflex",
  "Nimesulida 100mg",
  "Cetoprofeno 100mg",
  "Loratadina 10mg",
];

export const FREQUENCIES = [
  "1x ao dia",
  "2x ao dia (12/12h)",
  "3x ao dia (8/8h)",
  "4x ao dia (6/6h)",
  "A cada 4 horas",
  "Se necessário",
];
